import axios from "axios";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { loginSuccess, loginFailure } from "../authSlice";
import "../styling/Login.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import BookingHeader from "./clientPortal/BookingHeader";


const ForgotClientPassword = ({ handleIsclient }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const API_URL = process.env.REACT_APP_API_URL;
  // console.log(API_URL);
  // http://localhost:3001/business-user/login




  const handleReset = async () => {
    if (!email) {
      alert("Please enter your email to reset password");
      return;
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/client-user/forgot-client-password`, { email: email.toLowerCase() }, {withCredentials: true});
      navigate("/checkCode", { state: { email: email.toLowerCase(), userType: 'client'  } });
    } catch (error) {
      alert("Failed to initiate password reset. Please try again.");
    } 
  };

  return (
    <div>
      <BookingHeader/>
    <div
      className="login-page-container"
      
    >
      <div className="login-business" style={{ minHeight : "430px" }}>
        <div className="login-content" style={{ marginBottom: '30px' }} >
        <h1
          style={{
            fontSize: "24px",
            color: "#000000",
            marginBottom: "0px",
            fontWeight: "bold",
          }}
        >
          Reset Your Password
        </h1>
        <p style={{fontSize:"15px", color:"#4d4d4d", width: '70%', paddingLeft: '14%', marginTop: '5px'}}> Enter your mail and we'll send you intructions on how to reset your password</p>
        <input
          type="email"
          name="email"
          placeholder="Email"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: "100%",
            marginBottom: "5px",
            padding: "10px",
            boxSizing: "border-box",
            marginTop: '20px'
          }}
        />

      
        <button
          className="login-button"
          style={{ width: "100%", marginTop: "30px", padding: "10px", fontSize: '15px', background: 'linear-gradient(to right, #1C1154, #211074, #260F99 )' }}
          onClick={handleReset} 
        >
          Reset Password
        </button>
    
         <div style={{ paddingLeft: '1%', color: '#545454', marginTop: '30px' }}>
            {/* <p style={{ fontSize: '12px' }} > Go Back to  <Link to="/login"><span style={{ textDecoration: 'underline', color: '#545454' }}>login page</span></Link></p> */}
            </div>
      </div>
      </div>
    </div>
    </div>
  );
};

export default ForgotClientPassword;
